import {
  sysDict_queryItemList,
  querySystemConfig,
  initGtCapthca
} from "@/api/sysDict";
import { getLocalApiCoin, getApiCoin } from "@/lang";
import isEmpty from "lodash/isEmpty";

import {
  SET_SYSDICT_SYSTEMCONFIG,
  SAVE_APP_LANGUAGE,
  SAVE_SYSTEM_API_COIN
} from "@/store/mutation_types";

const sysDict = {
  state: {
    systemConfig: {},
    sysCurrency: {
      currency: "",
      currencyIcon: ""
    },
    sysLotteryMoney: {
      selfFlag: {},
      customAmount: {}
    },
    sysApiPhoneOpen: false,
    sysH5RedPacketSwitchL: false,
    handsFeeRechargeOpen: false,
    lotteryRoomStatus: false,
    sysApiCoinList: [],
    sysApiCoin: getLocalApiCoin(),
    sysDragon: "0"
  },
  getters: {
    sysDictSystemConfig: state => state.systemConfig,
    sysCurrency: state => state.sysCurrency,
    sysLotteryMoney: state => state.sysLotteryMoney,
    sysUserCostAmount: (state, getters) => {
      const { selfFlag = {} } = state.sysLotteryMoney;
      const { cur } = getters.sysApiCoin || {};
      return selfFlag[cur];
    },
    sysUserCustomAmount: (state, getters) => {
      const { customAmount = {} } = state.sysLotteryMoney;
      const { cur } = getters.sysApiCoin || {};
      return customAmount[cur];
    },
    getSysUserAmountBySelfFlag: (state, getters) => selfFlag => {
      if (selfFlag === "1") {
        return getters.sysUserCustomAmount;
      }
      return getters.sysUserCostAmount;
    },
    sysApiPhoneOpen: state => state.sysApiPhoneOpen,
    sysH5RedPacketSwitch: state => state.sysH5RedPacketSwitch,
    handsFeeRechargeOpen: state => state.handsFeeRechargeOpen,
    lotteryRoomStatus: state => state.lotteryRoomStatus,
    sysApiCoinList: state => state.sysApiCoinList,
    sysApiCoin: state => {
      if (state.sysApiCoin) {
        return state.sysApiCoin;
      }
      return state.sysApiCoinList[0] || {};
    },
    showSysDragon: state => {
      return state.sysDragon === "1";
    }
  },
  mutations: {
    [SET_SYSDICT_SYSTEMCONFIG]: (state, playload = {}) => {
      const {
        CURRENCY,
        lotteryMoney,
        API_PHONE_OPEN,
        WHOLE_REDPACKET_SWITCH,
        HANDSFEE_RECHARGE_OPEN,
        API_COIN_LIST,
        LOTTERY_ROOM_STATUS,
        dragon
      } = playload;
      if (CURRENCY) {
        state.sysCurrency = JSON.parse(CURRENCY);
      }
      if (lotteryMoney) {
        state.sysLotteryMoney = JSON.parse(lotteryMoney);
      }
      if (API_COIN_LIST) {
        try {
          state.sysApiCoinList = JSON.parse(API_COIN_LIST);
        } catch (e) {
          state.sysApiCoinList = {};
        }
      }
      state.sysApiPhoneOpen = API_PHONE_OPEN === "1";
      state.sysH5RedPacketSwitch = WHOLE_REDPACKET_SWITCH === "1";
      state.handsFeeRechargeOpen = HANDSFEE_RECHARGE_OPEN === "1";
      state.lotteryRoomStatus = LOTTERY_ROOM_STATUS === "1";
      state.systemConfig = playload;
      state.sysDragon = dragon;
    },
    [SAVE_SYSTEM_API_COIN](state, cur) {
      const coin =
        state.sysApiCoinList.find(coin => {
          return coin.cur === cur;
        }) || {};
      if (coin) {
        localStorage.setItem("api-coin", JSON.stringify(coin));
      } else {
        localStorage.clear("api-coin");
      }
      state.sysApiCoin = coin;
    }
  },
  actions: {
    async querySystemConfig({ state, commit, getters, dispatch }, playload) {
      const res = await querySystemConfig();
      if (res.data.code !== 0) {
        return;
      }
      // const {
      //   data: { data = {} }
      // } = rRes;
      const systemConfigData = {};
      res.data.data.forEach(item => {
        systemConfigData[item.key] = item.value;
      });
      // console.log('systemConfigData',systemConfigData)
      commit(SET_SYSDICT_SYSTEMCONFIG, systemConfigData);
      return systemConfigData;
    },
    async querySysDictItemList({ commit }, playload) {
      const rRes = await sysDict_queryItemList(playload);
      const {
        data: { data = {} }
      } = rRes;
      return data.itemList;
    },
    async initGtCapthca({ commit }, playload) {
      return await initGtCapthca(playload);
    }
  }
};

export default sysDict;
